import React from 'react';
import { Link } from 'react-router-dom';
import { OpsightLogo } from './OpsightLogo';
import { scrollToSection } from '../utils/config';
import './Footer.css';

export const Footer: React.FC = () => {
  const handleNavClick = (sectionId: string) => {
    scrollToSection(sectionId);
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <OpsightLogo size={120} variant="dark" />
            <p className="footer-tagline">
              Métricas do GitHub que importam. Dashboards que transformam dados em ação.
            </p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Produto</h4>
              <ul>
                <li>
                  <a href="#features" onClick={(e) => { e.preventDefault(); handleNavClick('features'); }}>
                    Features
                  </a>
                </li>
                <li>
                  <a href="#pricing" onClick={(e) => { e.preventDefault(); handleNavClick('pricing'); }}>
                    Preços
                  </a>
                </li>
                <li>
                  <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>
                    Sobre
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Suporte</h4>
              <ul>
                <li><a href="mailto:suporte@opsight.com">Contato</a></li>
                <li><a href="#docs">Documentação</a></li>
                <li><a href="#faq">FAQ</a></li>
                <li><Link to="/release-notes">Release Notes</Link></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Legal</h4>
              <ul>
                <li><a href="#privacy">Privacidade</a></li>
                <li><a href="#terms">Termos</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Opsight. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

